import {
  GetCurrentPoolConnection,
  ICurrentSetting,
  IGetCurrentSettingsResponseRecord,
} from "@services/getSettings";
import useApiRequests from "@services/http/useApiRequest";
import { useCallback, useEffect, useMemo, useState } from "react";
import { IShowProxySettingProps } from "./ShowProxySetting";
import { ALGO_PORTS } from "../../../../config";

const KEY_WORD_NISEHASH = "xnsub";

export const useProxySettingControl = (props: IShowProxySettingProps) => {
  const { enqueue } = useApiRequests();
  // const [currentSetting, setCurrentSetting] = useState<ICurrentSetting>(
  //   props.setting
  // );

  const ports = useCallback((key: keyof typeof ALGO_PORTS) => {
    return ALGO_PORTS[key];
  }, []);

  const findPort = (hash: keyof typeof ALGO_PORTS) => {
    return ports(hash);
  };

  const checkPool = (num: 0 | 1 | 2) => {
    switch (num) {
      case 0:
        return "ams";
      case 1:
        return "sgp";
      case 2:
        return "nyc";
      default:
        return "ams";
    }
  };

  // const postfix = useMemo(() => {
  //   if (!currentSetting?.Props) return;

  //   const v = JSON.parse(currentSetting.Props || "{}")?.extension || "";

  //   if (currentSetting?.Props.includes(KEY_WORD_NISEHASH)) {
  //     return `#${v}`;
  //   }
  //   return "";
  // }, [currentSetting?.Address]);

  return {
    // postfix,

    ports,
    findPort,
    checkPool,
  };
};
